import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@kanos/ui';
import { SearchX, TriangleAlert } from 'lucide-react';
import { useEffect } from 'react';
import { ApiError } from './api.js';
import { kanosVersion } from './app-footer.js';
/** The tab's title: the page, then Kanos - so a person with many tabs finds this one. */
export function usePageTitle(title) {
    useEffect(() => {
        document.title = `${title} · Kanos`;
    }, [title]);
}
/** A page that has nothing to show but what happened, inside the frame of the app. */
function PageState({ icon: Icon, title, text, children, }) {
    usePageTitle(title);
    return (_jsxs("section", { className: "glass mx-auto grid max-w-lg justify-items-center gap-4 rounded-lg p-8 text-center", children: [_jsx(Icon, { "aria-hidden": true, className: "size-8 text-muted" }), _jsx("h1", { className: "text-2xl font-semibold tracking-[-0.02em]", children: title }), _jsx("p", { className: "text-muted", children: text }), _jsx("div", { className: "flex flex-wrap justify-center gap-3", children: children })] }));
}
/** An address the app does not know: back to the start. */
export function NotFoundState({ onHome }) {
    return (_jsx(PageState, { icon: SearchX, title: "Diese Seite gibt es nicht", text: "Vielleicht hat sich die Adresse ge\u00E4ndert, oder der Link war unvollst\u00E4ndig.", children: _jsx(Button, { onPress: onHome, children: "Zur Startseite" }) }));
}
/**
 * A view that failed to load: the navigation stays, the person tries again - and support can
 * find the case by its reference (the failed API operation and its error code, if there was one).
 */
export function ErrorState({ error, onRetry, onHome, }) {
    const reference = error instanceof ApiError ? `${error.operation} · ${error.code}` : null;
    return (_jsxs(PageState, { icon: TriangleAlert, title: "Diese Ansicht konnte nicht geladen werden", text: reference
            ? `Bitte versuchen Sie es erneut. Kennung für den Support: ${reference} · Version ${kanosVersion()}`
            : 'Bitte versuchen Sie es erneut.', children: [_jsx(Button, { onPress: onRetry, children: "Erneut versuchen" }), _jsx(Button, { variant: "secondary", onPress: onHome, children: "Zur Startseite" })] }));
}
//# sourceMappingURL=page-state.js.map